import React, { useState, useEffect } from 'react';
import RTStartSession from './RTStartSession';
import RTScheduledSessions from './RTScheduledSessions';
import RTActiveSessions from './RTActiveSessions';
import RTCompletedSessions from './RTCompletedSessions';
import RTTLive from './RTTLive';
import RTTHistory from './RTTHistory';
import realTimeDeviceService from '../../services/realTimeDeviceService';
import '../assets/RemoteDebugSessionTabs.css';

/**
 * Real-Time Device Management — second-level tab container.
 *
 * Uses the portal's custom sub-tab pattern (same as RemoteDebugSessionTabs /
 * DeviceDiagnostics), NOT antd Tabs. Owns Start / Scheduled / Active / Completed
 * sub-tabs. Starting a session from the Start tab switches to Active.
 */
function RealTimeDeviceManagement({ userInfo, role, userGroups = [], prefilledSystemId, setPrefilledSystemId }) {
  const subTabs = [
    { key: 'Start', label: 'Start' },
    { key: 'Scheduled', label: 'Scheduled' },
    { key: 'Active', label: 'Active' },
    { key: 'Completed', label: 'Completed' },
    { key: 'Live', label: 'Live' },
    { key: 'History', label: 'History' },
  ];

  const [activeSubTab, setActiveSubTab] = useState('Start');

  useEffect(() => {
    const email = typeof userInfo === 'string'
      ? userInfo
      : (userInfo?.mail || userInfo?.email || '');
    realTimeDeviceService.setUserContext(email, role);
  }, [userInfo, role]);

  useEffect(() => {
    if (prefilledSystemId) {
      setActiveSubTab('Start');
    }
  }, [prefilledSystemId]);

  const handleSessionStarted = (created) => {
    // Scheduled sessions land in the Scheduled tab; immediate ones in Active.
    setActiveSubTab(created && created.status === 'scheduled' ? 'Scheduled' : 'Active');
  };

  const renderSubTabContent = () => {
    switch (activeSubTab) {
      case 'Start':
        return <RTStartSession userInfo={userInfo} onSessionStarted={handleSessionStarted} prefilledSystemId={prefilledSystemId} setPrefilledSystemId={setPrefilledSystemId} />;
      case 'Scheduled':
        return <RTScheduledSessions onScheduleSession={() => setActiveSubTab('Start')} />;
      case 'Active':
        return <RTActiveSessions userInfo={userInfo} onNewSession={() => setActiveSubTab('Start')} />;
      case 'Completed':
        return <RTCompletedSessions />;
      case 'Live':
        return <RTTLive />;
      case 'History':
        return <RTTHistory />;
      default:
        return <RTStartSession userInfo={userInfo} onSessionStarted={handleSessionStarted} />;
    }
  };

  return (
    <div className="remote-debug-session-container">
      <div className="sub-tab-content">
        <div className="sub-tabs-container nested">
          {subTabs.map((tab) => (
            <div
              key={tab.key}
              className={`sub-tab ${activeSubTab === tab.key ? 'active' : ''}`}
              onClick={() => setActiveSubTab(tab.key)}
            >
              {tab.label}
            </div>
          ))}
        </div>
        {renderSubTabContent()}
      </div>
    </div>
  );
}

export default RealTimeDeviceManagement;
